enableFormSubmit = function (val) {
  var sbmt = $(val).parent().parent().parent().find('button[type=submit]');
  if (val.checked === true) {
    $(sbmt).closest('button').removeClass('disabled');
    sbmt.disabled = false;
  } else {
    $(sbmt).closest('button').addClass('disabled');
    sbmt.disabled = true;
  }
};

scrollToAnchor = function (val) {
  location.hash = $(val).data('hash');
  let uri = window.location.toString();
  if (uri.indexOf("#") > 0) {
    let cleanUri = uri.substring(0, uri.indexOf("#"));
    window.history.replaceState({}, document.title, cleanUri);
  }
};

$(document).ready(function () {
  $("input[name='phone']").inputmask({"mask": "+7 (999) 999-99-99"});
  $('span.sum-value').html($('input.sum').val().split('').reverse().join('').match(/.{1,3}/g).join(' ').split('').reverse().join(''));
  $('.option[data-value="3"]').click();
  // console.log($('input.sum').val());
});

$('button[type=submit]').on('click', function () {
  let emailRegexp = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;
  let name = $(this).closest('form').find("input[name='name']");
  let phone = $(this).closest('form').find("input[name='phone']");
  let email = $(this).closest('form').find("input[name='email']");

  if (phone.val().replace(/[ _-]/g, '').length < 14) {
    $(phone).addClass('error');
  } else {
    $(phone).removeClass('error');
  }

  if (name.val().length <= 0) {
    $(name).addClass('error');
  } else {
    $(name).removeClass('error');
  }

  if (!emailRegexp.test(email.val())) {
    $(email).addClass('error');
  } else {
    $(email).removeClass('error');
  }

  if ($(this).closest('form').find('.error').length === 0) {
    let formData = $(this).closest('form').serializeArray();

    $.ajax({
      url: '/tour/',
      type: 'post',
      data: formData,
      success: function (res) {
        let result = $.parseJSON(res);
        // console.log(result)
        $('.form-info--count .number').html(result);
        $(phone).val("");
        $(name).val("");
        $(email).val("");
        $('.modal').addClass('show');
      },
      error: function (res) {
        console.log(res);
      }
    });
  }
  return false;
});

$('.modal a').on('click', function () {
  $('.modal').removeClass('show');
  return false;
});

$('.format-card').on('click', function() {
  if (!$(this).hasClass('active')) {
    $('.format-card.active').removeClass('active');
    $(this).addClass('active');
  }
});

const formatter = new Intl.NumberFormat('ru-Ru', {
  minimumFractionDigits: 0,
});

$('.format-card .card-property.options .option').on('click', function() {
  let totalValue = $('.format-card .card-footer .price-block .total-value');
  let discountEl = $('.format-card .card-footer .price-block span.discount').html();
  let perMonth = $('.format-card .card-footer .price-block .per-month');
  let bonusEl = $('.format-card .card-footer .price-block .bonus');
  let discountHtml = '<span class="discount">-15%</span>';
  let curSymbol = ' р.';
  let discountVal = $(this).find('.notice').html();
  let sum = '';

  if (!$(this).hasClass('active')) {
    $('.card-property.options .option.active').removeClass('active');
    $(this).addClass('active');

    if ($(this).data('value') === 'exp') {
      $(this).closest('.format-card').find('.card-footer').addClass('d-none');
      $(this).closest('.format-card').find('.card-footer.exponent').removeClass('d-none');
      $('.discount').detach();
      $(totalValue).html('бесплатно');
    } else {
      $(this).closest('.format-card').find('.card-footer').removeClass('d-none');
      $(this).closest('.format-card').find('.card-footer.exponent').addClass('d-none');
      if ($(this).data('value') === 1) {
        $(bonusEl).addClass('d-none');
      } else {
        $(bonusEl).removeClass('d-none');
      }

      // String($(this).data('cost')).split('').reverse().join('').match(/.{1,3}/g).join(' ').split('').reverse().join('')
      $(perMonth).html(
        $(this).data('cost') +' р.\\мес');
      if (discountVal.trim().length !== 0) {
        sum = '<span class="discount">'+discountVal.trim()+'</span>';
        }
      $(totalValue).html(
        formatter.format(
          $(this).data('cost')*$(this).data('value')
        )+curSymbol+sum
      );
    }
  }
});

$('input.sum').on('input', function(e) {
  if (this.value.length > 7) {
    this.value = this.value.slice(0,7);
  };

  let val = this.value.split('').reverse().join('').match(/.{1,3}/g).join(' ').split('').reverse().join('');
  $('span.sum-value').html(val);
});

const swiper = new Swiper('.swiper', {
  loop: false,
  spaceBetween: 0,
  allowTouchMove: true,
  autoHeight: true,
  width: 538,
  initialSlide: 0,
  breakpoints: {
    280: {
      enabled: true,
      width: 272,
      initialSlide: 1,
      // centeredSlides: true,
      // centerInsufficientSlides: true,
    },
    480: {
      // slidesPerView: 3,
      // spaceBetween: 30
    },
    640: {
      enabled: false
    },
    2200: {
    }
  },
  on: {
    slideChange: function () {
    },
  },
});
